import edap from '@homeaway/edap-wrapper';

import {transformStringToLowerCase} from '../stringUtils';

// EDAP EVENTS
export const BOOKING_REQUEST_CANCELLATION_DISMISSED =
    'booking_request_cancellation.dismissed';
export const BOOKING_REQUEST_CANCELLATION_SUBMITTED =
    'booking_request_cancellation.submitted';
export const BOOKING_REQUEST_CANCELLATION_SUCCEEDED =
    'booking_request_cancellation.succeeded';
export const CANCEL_BOOKING_REQUEST_PRESENTED =
    'cancel_booking_request.presented';
export const CANCEL_BOOKING_REQUEST_SELECTED =
    'cancel_booking_request.selected';
export const GENERIC_EVENT = 'generic.event';
export const MODIFY_BOOKING_CANCELLATION_POLICY_SELECTED =
    'modify_booking_cancellation_policy.selected';
export const MODIFY_BOOKING_REQUEST_CONFIRMATION_PRESENTED =
    'modify_booking_request_confirmation.presented';
export const MODIFY_BOOKING_REQUEST_DETAILS_PRESENTED =
    'modify_booking_request_details.presented';
export const MODIFY_BOOKING_REQUEST_FAILED = 'modify_booking_request.failed';
export const MODIFY_BOOKING_REQUEST_ERROR_PRESENTED =
    'modify_booking_request_error.presented';
export const MODIFY_BOOKING_REQUEST_PRESENTED =
    'modify_booking_request.presented';
export const MODIFY_BOOKING_REQUEST_SELECTED =
    'modify_booking_request.selected';
export const MODIFY_BOOKING_REQUEST_SUBMITTED =
    'modify_booking_request.submitted';
export const MODIFY_BOOKING_REQUEST_SUCCEEDED =
    'modify_booking_request.succeeded';
export const THINGS_TO_DO_ACTIVITY_SELECTED = 'things_to_do_activity.selected';
export const TRIP_DETAILS_PRESENTED = 'trip_details.presented';
export const UX_DATES_VISIBLE_ADJUSTED = 'ux.dates_visible.adjusted';
export const UX_DATE_PICKER_HIDDEN = 'ux.date_picker.hidden';
export const UX_DATE_PICKER_PRESENTED = 'ux.date_picker.presented';

// ACTION LOCATIONS
export const MODIFY_BOOKING = 'modify_booking';
export const TRIPS = 'trips';
export const TRIP_DETAILS = 'trip_details';

// ACTION TYPE
export const MODIFY_REQUEST = 'modify_request';

export const triggerEdap = (name, data) => {
    edap().push({
        name,
        data,
    });
};

export const bookingRequestCancellationDismissed = ({
    actionLocation,
    reservationUUID,
}) => {
    triggerEdap(BOOKING_REQUEST_CANCELLATION_DISMISSED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
    });
};

export const bookingRequestCancellationSubmitted = ({
    actionLocation,
    adults,
    children,
    category,
    reason,
    reservationUUID,
    reservationArrival,
    reservationDeparture,
}) => {
    triggerEdap(BOOKING_REQUEST_CANCELLATION_SUBMITTED, {
        action_location: actionLocation,
        adult_count: `${adults}`,
        child_count: `${children}`,
        cancellation_category: transformStringToLowerCase(category),
        cancellation_reason: transformStringToLowerCase(reason),
        reservation_id: reservationUUID,
        date_end: reservationDeparture,
        date_start: reservationArrival,
    });
};

export const bookingRequestCancellationSucceeded = ({
    actionLocation,
    reservationUUID,
}) => {
    triggerEdap(BOOKING_REQUEST_CANCELLATION_SUCCEEDED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
    });
};

export const cancelBookingRequestPresented = ({
    actionLocation,
    experienceType,
    reservationUUID,
}) => {
    triggerEdap(CANCEL_BOOKING_REQUEST_PRESENTED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const cancelBookingRequestSelected = ({
    actionLocation,
    reservationUUID,
}) => {
    triggerEdap(CANCEL_BOOKING_REQUEST_SELECTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
    });
};

export const modifyBookingCancellationPolicySelected = ({
    actionLocation,
    experienceType,
    reservationUUID,
}) => {
    triggerEdap(MODIFY_BOOKING_CANCELLATION_POLICY_SELECTED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const modifyBookingRequestConfirmationPresented = ({
    actionLocation,
    experienceType,
    reservationUuid,
}) => {
    triggerEdap(MODIFY_BOOKING_REQUEST_CONFIRMATION_PRESENTED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUuid,
    });
};

export const modifyBookingRequestDetailsPresented = ({
    actionLocation,
    experienceType,
    reservationUUID,
}) => {
    triggerEdap(MODIFY_BOOKING_REQUEST_DETAILS_PRESENTED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const modifyBookingRequestErrorPresented = ({
    actionLocation,
    experienceType,
    reservationUUID,
}) => {
    triggerEdap(MODIFY_BOOKING_REQUEST_ERROR_PRESENTED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const modifyBookingRequestFailed = ({
    actionLocation,
    experienceType,
    reservationUUID,
}) => {
    triggerEdap(MODIFY_BOOKING_REQUEST_FAILED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const modifyBookingRequestPresented = ({
    actionLocation,
    experienceType,
    reservationUUID,
}) => {
    triggerEdap(MODIFY_BOOKING_REQUEST_PRESENTED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const modifyBookingRequestSelected = ({
    actionLocation,
    experienceType,
    reservationUUID,
}) => {
    triggerEdap(MODIFY_BOOKING_REQUEST_SELECTED, {
        action_location: actionLocation,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const modifyBookingRequestSubmitted = (params) => {
    const {
        actionLocation,
        experienceType,
        oldAdultCount,
        newAdultCount,
        oldChildCount,
        newChildCount,
        oldStartDate,
        oldEndDate,
        newStartDate,
        newEndDate,
        reservationUUID,
    } = params;

    triggerEdap(MODIFY_BOOKING_REQUEST_SUBMITTED, {
        action_location: actionLocation,
        adult_count: oldAdultCount,
        adult_count_new: newAdultCount,
        child_count: oldChildCount,
        child_count_new: newChildCount,
        date_start: oldStartDate,
        date_end: oldEndDate,
        date_start_new: newStartDate,
        date_end_new: newEndDate,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const modifyBookingRequestSucceeded = (params) => {
    const {
        actionLocation,
        experienceType,
        oldAdultCount,
        newAdultCount,
        oldChildCount,
        newChildCount,
        oldStartDate,
        oldEndDate,
        newStartDate,
        newEndDate,
        reservationUUID,
    } = params;

    triggerEdap(MODIFY_BOOKING_REQUEST_SUCCEEDED, {
        action_location: actionLocation,
        adult_count: oldAdultCount,
        adult_count_new: newAdultCount,
        child_count: oldChildCount,
        child_count_new: newChildCount,
        date_start: oldStartDate,
        date_end: oldEndDate,
        date_start_new: newStartDate,
        date_end_new: newEndDate,
        experience_type: experienceType,
        reservation_id: reservationUUID,
    });
};

export const thingsToDoActivitySelected = ({
    actionLocation,
    activityDescription,
    activityPriceAmount,
    activityType,
    reservationUUID,
}) => {
    triggerEdap(THINGS_TO_DO_ACTIVITY_SELECTED, {
        action_location: actionLocation,
        activity_description: activityDescription,
        activity_price_amount: `${activityPriceAmount}`,
        activity_type: activityType.join(', '),
        reservation_id: reservationUUID || '-1',
    });
};

export const triggerGenericEvent = (params) => {
    triggerEdap(GENERIC_EVENT, {
        ...params,
    });
};

export const tripDetailsPresented = ({
    actionLocation,
    reservationUuid,
    redirectSource,
    redirectSourceType,
}) => {
    const data = {
        action_location: actionLocation,
        reservation_id: reservationUuid,
    };
    if (redirectSource && redirectSourceType) {
        data.redirect_link_source = redirectSource;
        data.redirect_link_source_type = redirectSourceType;
    }
    triggerEdap(TRIP_DETAILS_PRESENTED, data);
};

export const uxDatesVisibleAdjusted = ({
    actionLocation,
    startDate,
    endDate,
}) => {
    triggerEdap(UX_DATES_VISIBLE_ADJUSTED, {
        action_location: actionLocation,
        date_start: startDate,
        date_end: endDate,
    });
};

export const uxDatePickerHidden = ({actionLocation}) => {
    triggerEdap(UX_DATE_PICKER_HIDDEN, {
        action_location: actionLocation,
    });
};

export const uxDatePickerPresented = ({actionLocation}) => {
    triggerEdap(UX_DATE_PICKER_PRESENTED, {
        action_location: actionLocation,
    });
};
